import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import { BudgetForm } from '@/components/BudgetForm/BudgetForm'
import type { BudgetFormSchema } from '@/components/BudgetForm/BudgetForm.types'
import { budgetFormDefaultValues } from '@/components/BudgetForm/BudgetForm.values'
import type { BudgetFormAddProps } from '@/components/BudgetFormAdd/BudgetFormAdd.types'

import {
  useBudgetServiceBudgetControllerAddBudget,
  useBudgetServiceBudgetControllerGetAllBudgetsKey,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

const INVALIDATE_KEYS = [
  useBudgetServiceBudgetControllerGetAllBudgetsKey,
  INSIGHTS_QUERY_KEY,
]

export function BudgetFormAdd({ currentBudget, onClose }: BudgetFormAddProps) {
  const queryClient = useQueryClient()

  const initialValues = budgetFormDefaultValues()

  const createBudget = useBudgetServiceBudgetControllerAddBudget({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Budget created successfully',
        title: 'Budget created',
      })

      INVALIDATE_KEYS.forEach(key => {
        queryClient.invalidateQueries({
          queryKey: [key],
        })
      })

      onClose()
    },
  })

  const handleSubmit = (values: BudgetFormSchema) => {
    createBudget.mutate({
      requestBody: values,
    })
  }

  return (
    <BudgetForm
      currentBudget={currentBudget}
      data={initialValues}
      edit={false}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}
